import AppleIcon from "@mui/icons-material/Apple";
import ShopOutlinedIcon from "@mui/icons-material/ShopOutlined";
import { Stack, Tooltip, Typography } from "@mui/material";
import { FieldProps, useFieldValue } from "react-admin";

type StoreRef = { store: string; sku: string };

const STORE_CONFIG: Record<string, { icon: typeof AppleIcon; label: string }> = {
    app_store: { icon: AppleIcon, label: "App Store" },
    play_store: { icon: ShopOutlinedIcon, label: "Play Store" },
};

const StoreIcon = ({ store }: { store: string }) => {
    const config = STORE_CONFIG[store];
    if (!config) {
        return null;
    }

    const Icon = config.icon;

    return (
        <Tooltip title={config.label}>
            <Icon fontSize="small" sx={{ color: "text.secondary" }} />
        </Tooltip>
    );
};

export const StoreRefsField = (props: FieldProps) => {
    const storeRefs = useFieldValue(props) as StoreRef[] | undefined;

    if (!storeRefs?.length) {
        return null;
    }

    return (
        <Stack spacing={0.25}>
            {storeRefs.map(({ store, sku }) => (
                <Stack
                    key={`${store}-${sku}`}
                    direction="row"
                    alignItems="center"
                    spacing={1}
                    sx={{ border: "1px solid #e0e0e0", borderRadius: "4px", padding: "4px" }}
                >
                    <StoreIcon store={store} />
                    <Typography
                        variant="caption"
                        color="text.secondary"
                        lineHeight={1.3}
                        noWrap
                    >
                        {sku}
                    </Typography>
                </Stack>
            ))}
        </Stack>
    );
};
